import { FileReader, FileWriter } from '@/platform'
import ModuleId from './DataStructModuleId'
import Str from './Str'

class GameStr {
    public mid = ModuleId.gameStr
    public Data: Array<Str> = new Array()
    constructor(isEx: boolean = false) {
        this.Data = []
        this.DataInit()
    }

    DataInit() {
        this.Data.push(new Str('演示用字符串', '范例1'))
        this.Data.push(new Str('字符串可以用\v[变量编号]，来显示对应编号的变量值', '范例2'))
        for (let i: number = 0; i < 48; i++) {
            this.Data.push(new Str('', ''))
        }
    }

    readBin(reader: FileReader): void {
        const len = reader.readInt()
        this.Data = []
        for (var i = 0; i < len; i++) {
            let str = new Str()
            str.readBin(reader)
            this.Data.push(str)
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.Data.length)
        for (let i = 0; i < this.Data.length; i++) {
            var str = this.Data[i]
            if (str instanceof Str === false) {
                str = Object.assign(new Str(), str)
            }
            str.writeBin(writer)
        }
    }

    readVersionedOui(reader: FileReader): void {
        const len = reader.readInt()
        this.Data = []
        for (var i = 0; i < len; i++) {
            let str = new Str()
            str.readVersionedOui(reader.readObj(reader.readInt()))
            this.Data.push(str)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.Data.length)
        for (let i = 0; i < this.Data.length; i++) {
            var str = this.Data[i]
            if (str instanceof Str === false) {
                str = Object.assign(new Str(), str)
            }
            str.writeVersionedOui(writer)
        }

        writer.writerLength()
    }
}

export default GameStr
